import React, {useEffect, useState} from 'react';
import {Alert, Col, Input, Label, PopoverBody, Row, UncontrolledPopover} from 'reactstrap';
import {func} from "prop-types";
import Badge from "reactstrap/es/Badge";
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
let commonStrings = new LocalizedStrings(common_strings);

const ScannerAlert = (props) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        on_scanner()
    }, [])

    const onDismiss = () => {
        props.toggleScanner()
        setVisible(false)
    };

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    localize();

    return (
        <Alert color="default" isOpen={visible} toggle={onDismiss} fade={true} style={{width: "100%"}} >
            <Row style={{
                display: "flex",
                alignItems: "center"
            }}>
                <Col lg="9">
                    <Label style={{color: "dark"}}
                           className="fas fa-qrcode mr-2"/> {commonStrings.scan_state_scanning_expl}
                    <Badge id="info_popover" className="badge-whit ml-2"> info </Badge>
                    <UncontrolledPopover placement="top" target="info_popover">
                        <PopoverBody>{commonStrings.scanning_expl}</PopoverBody>
                    </UncontrolledPopover>
                </Col>
                <Col>
                <Input type="text" id="scanner" placeholder={commonStrings.scan_state_scanning} style={{backgroundColor: "black", textAlign: "center" }}/>
                </Col>
            </Row>
        </Alert>
    );

    function on_scanner() {
        let is_event = false; // for check just one event declaration
        let input = document.getElementById("scanner");
        input.addEventListener("focus", function () {
            if (!is_event) {
                is_event = true;
                input.addEventListener("keypress", function (e) {
                    setTimeout(function () {
                        if (e.keyCode === 13) {
                            if (input.value === '') return;
                            console.log(input.value)
                            props.onScanResult(input.value)
                            document.getElementById('scanner').value = "";
                            document.getElementById('scanner').value = commonStrings.scan_state_scanning;
                            //input.select();
                        }
                    }, 500)
                })
            }
        });
        document.addEventListener("keypress", function (e) {
            if (e.target.tagName !== "INPUT") {
                input.focus();
            }
        });
    }

};

export default ScannerAlert;